/**
 * Public routes render without Keycloak. Keep this list tiny and explicit —
 * every pattern here is a page anyone on the internet can load.
 */
const publicRoutePatterns: RegExp[] = [/^\/finance\/?$/]

export const isPublicRoute = (
    pathname: string = window.location.pathname
): boolean => publicRoutePatterns.some((pattern) => pattern.test(pathname))
